import {i18n} from '@/plugins/i18n'

export const WalletLockStatus = {
    UNLOCK:         1,
    LOCK:           2,
    PERMANENT_LOCK: 3,
};

export const WalletLockStatusStr = {
    UNLOCK:         i18n.t('wallets.lock_status.unlock'),
    LOCK:           i18n.t('wallets.lock_status.lock'),
    PERMANENT_LOCK: i18n.t('wallets.lock_status.permanent_lock'),

    get(status) {
        let status_str = null;

        Object.keys(WalletLockStatus).forEach(item => {
            if (WalletLockStatus[item] === status) {
                status_str = WalletLockStatusStr[item];
            }
        });

        return status_str;
    }
};
